<p-paginator [first]="first()" [rows]="rows()" [totalRecords]="totalRecords()"
    [rowsPerPageOptions]="rowsPerPageOptions" (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando {first} al {last} de {totalRecords} registros" />
